// extracted by mini-css-extract-plugin
module.exports = {"connect":"connect_connect__38j98","icon":"connect_icon__1ypW1"};